export const monthly = 'monthly';
export const quarterly = 'quarterly';
export const yearly = 'yearly';
export const prepaid = 'prepaid';

export const paymentInterval = [monthly, quarterly, yearly, prepaid] as const;
export type PaymentInterval = typeof paymentInterval[number];
